import React, { createContext, useMemo, useState } from 'react'
import LoadingModal from 'components/Modals/LoadingModal'

export const initialHideLoading = {
  message: '',
  error: false,
  duration: 0,
  showFeedbackMessage: false,
}

export const initialfetch = {
  method: '',
  endpoint: '',
  body: undefined,
  showToast: false,
  showLoading: true,
  toastOptions: {
    showFeedbackMessage: false,
    resultMessageSuccess: '',
    resultMessageError: '',
    duration: 0,
  },
}

export const loadingContext = createContext({
  setLoading: () => {},
  loading: false,
})
const LoadingContext = ({ children }) => {
  const [loading, setLoading] = useState(false)

  const contextValue = useMemo(
    () => ({
      setLoading,
      loading,
    }),
    [loading],
  )
  return (
    <>
      {loading && <LoadingModal />}
      <loadingContext.Provider value={contextValue}>
        {children}
      </loadingContext.Provider>
    </>
  )
}

export default LoadingContext
